import React from 'react';
import './AmenidadesDesc.scss';
import Slider from '../Slider/SliderStatic';
import { SwiperSlide } from "swiper/react";
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";
import { useTranslation } from 'react-i18next';

const AmenidadesDesc = (props) => {
  const { t } = useTranslation();

  return (
    <div id="amenmapa" className='contenedor_amenidades_desc'>
      <img className='contenedor_amenidades_desc_fondo' src="/assets/img-velasur-privada-acacia.jpg" alt="" />
      <div className="contenedor_amenidades_desc__slider">
        <div className='contenedor_amenidades_desc__slider_card'>
          <AnimationOnScroll
            duration={2}
            animateOnce={true}
            animateIn='animate__fadeIn'>
            <div className='contenedor_amenidades_desc__slider_card_logo'>
              <img src="/assets/Artemisa/img-logo-artemisa.svg" alt="Logo Artemisa" />
            </div>
          </AnimationOnScroll>
          <div className='contenedor_amenidades_desc__slider_card_metros'>
            <p>{t('amenitiesDescArtemisa.lots')}</p>
          </div>
          <div className='contenedor_amenidades_desc__slider_card_lista'>
            <div className='amenidad'>
              <div>
                <img src="/assets/Iconos/svg-icon-iso.svg" alt="icono" />
                <p>{t('amenitiesDescArtemisa.clubhouse')}</p>
              </div>
            </div>
            <div className='amenidad'>
              <div>
                <img src="/assets/Iconos/svg-icon-iso.svg" alt="icono" />
                <p>{t('amenitiesDescArtemisa.greenArea')}</p>
              </div>
            </div>
            <div className='amenidad'>
              <div>
                <img src="/assets/Iconos/svg-icon-iso.svg" alt="icono" />
                <p>{t('amenitiesDescArtemisa.privatePool')}</p>
              </div>
            </div>
            
           
            <div className='amenidad'>
              <div>
                <img src="/assets/Iconos/svg-icon-iso.svg" alt="icono" />
                <p>{t('amenitiesDescArtemisa.controlledAccess')}</p>
              </div>
            </div>
            <div className='amenidad'>
              <div>
                <img src="/assets/Iconos/svg-icon-iso.svg" alt="icono" />
                <p>{t('amenitiesDescArtemisa.recreationalAreas')}</p>
              </div>
            </div>
          </div>
          <div className='button_dispo'>
            <a href='https://disponibilidad.velasur.mx/privada-artemisa'>
              {t('amenitiesDesc.seeAvailability')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AmenidadesDesc;
